import clsx from 'clsx'
import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toggleDrawer } from 'src/redux/slices/project/reducers'
import { selectDrawerOpen } from 'src/redux/slices/project/selectors'

import { Divider, Drawer, Typography } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

import Survey from './Survey'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      width: '500px',
      marginTop: '5rem',
    },
    drawerTitle: {
      marginBottom: '1rem',
      textAlign: 'center',
      width: '100%',
    },
    divider: {
      width: '50%',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginBottom: '1rem',
    },
    dividerTop: {
      width: '90%',
      marginBottom: '0px',
    },
  }),
)

const SurveyDrawer: React.FC = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const drawerOpen = useSelector(selectDrawerOpen)
  const toggle = useCallback(() => {
    dispatch(toggleDrawer())
  }, [dispatch])
  return (
    <Drawer open={drawerOpen} onClose={toggle} anchor='left' PaperProps={{ color: 'primary' }}>
      <div className={classes.drawer}>
        <Typography variant='h5' className={classes.drawerTitle}>
          Project Info
        </Typography>
        <Divider className={classes.divider} />
        <Divider className={clsx(classes.divider, classes.dividerTop)} />
        <Survey isDrawer={true} />
      </div>
    </Drawer>
  )
}

export default SurveyDrawer
